module.exports = __webpack_public_path__ + "static/media/inter-medium.f6cf0a0b.woff2";